import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import UserNavbar from "@/components/UserNavbar.vue";
import UserFooter from "@/components/UserFooter.vue";
import { useRouter } from "vue-router";
import { USER_ROUTES } from "@/assets/route_constants";

export default /*@__PURE__*/_defineComponent({
  __name: 'Root',
  setup(__props) {

const router = useRouter();
router.push({ name: USER_ROUTES.Home.Name });

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(UserNavbar),
    _createVNode(_component_router_view),
    _createVNode(UserFooter)
  ]))
}
}

})